__webpack_require__.p = "/coding-school/_next/";